var track25=false;
var track50=false;
var track75=false;
var track90=false;
var track100=false;

initListeners=function(){
  var lastScrollTop = 0;

  $(window).scroll(function(event) {
    valorScroll=$(window).scrollTop();

    var st = valorScroll;
    if (st > lastScrollTop){
      // añade clase "enpantalla" cuando aparece en pantalla
      $(".js-aparece-scroll").each(function(index, el) {
        if ($(this).offset().top<=valorScroll){
          //$(this).addClass("enpantalla");
          var obj=$(this);
          if (obj.attr("dtm-medido")==0 && medirScroll){
            console.log(">DTM>"+obj.data("dtm"))
            obj.attr("dtm-medido",1);
            DTM.trackEvent(DTM.events.SCROLL, {"scrollLevel": "especiales:yelultimohombre:"+obj.data("dtm")});
          }
        }else{
          //$(this).removeClass("enpantalla");
        }
      });
    }else{
      $(".js-aparece-scroll").each(function(index, el) {
        if ($(this).offset().top>=valorScroll && $(this).offset().top<=(valorScroll+altoventana)){
          var obj=$(this);
          if (obj.attr("dtm-medido")==0 && medirScroll){
            console.log(">DTM>"+obj.data("dtm"))
            obj.attr("dtm-medido",1);
            DTM.trackEvent(DTM.events.SCROLL, {"scrollLevel": "especiales:yelultimohombre:"+obj.data("dtm")});
          }
        }
      });
    }
    lastScrollTop = st;

    if(valorScroll>60){
      $("header").addClass("fixed");
    }else{
      $("header").removeClass("fixed");
    }

      

  });

  /**
   * LISTENER validador formularios
   */
  $('.js-form-validator').validator(customValidations()).on('submit', function (e) {
    if ($(this).data('enviar-ajax') == undefined || $(this).data('enviar-ajax') == true){
          enviar_por_ajax = true;
    }else{
          enviar_por_ajax = false;
    }

    if (e.isDefaultPrevented() ) {
      $(this).find('.has-error').each(function(index, element){
        // console.log("hay errores");
      });
    }
    else{
      //console.log('pasa');
        if ($(this).data('spinner-holder') != ''){
          spinner_holder = $($(this).data('spinner-holder')).find('.js-spinner-holder');
        }else{
          $('body').find('.js-spinner-holder');
        }
        spinner_holder.fadeIn();

        // Si hay que enviarlo por ajax ejecutamos simpleAjaxForm, si no, dejamos que haga el submit
        $(this).find("button[type='submit']").addClass('btn-loader');
        if (enviar_por_ajax){
          //console.log('enviar ajax');
          if ($(this).data('archivos')){
            //console.log('ini');
              $(this).simpleAjaxFormFiles();
          }
          else{
              $(this).simpleAjaxForm();
          }    
              e.preventDefault();
        }

    } 
  });

  /**
   * LISTENER para mostrar/ocultar objetos
   */
  $(".js-toggle-div").click(function(){
    var obj=$(this).data("toggle-div");
    $(obj).toggleClass("desactivo");
  })

  /**
   * LISTENER menus con ancla
   */
  $(".js-menu-ancla").click(function(e){
    e.preventDefault();
    var ancla=$(this).attr("href");
    var offset=$(this).data("menuancla-offset");
    if(offset=="" || offset==undefined){
      offset=0;
    }
    console.log(ancla);
    PLG_scrollTo(1,ancla,0,offset,0);

    //cierro menu mobile
    if($(".navbar-collapse").hasClass("show")){
      $(".navbar-toggler").trigger("click");
    }
  })

  /**
   * LISTENER para despliegue menú hamburguesa
   */
  $('#menu_desplegable').on('show.bs.collapse', function () {
    PLG_showMenu();
    PLG_closeModalLogin();
  });
  $("#menu_desplegable .close").click(function(){
    PLG_closeMenu();
  });

  /**
   * LISTENER para mostrar modal login
   */
  $(".js-btn-header-login").click(function(){
    if($("#menu_desplegable").hasClass("show")){
      PLG_closeMenu(function(){
         PLG_toggleModalLogin();
      });
    }else{
      PLG_toggleModalLogin();
    }
  });

  /**
   * LISTENER para mostrar modal alerta
   */
  $(".js-modal-alerta").click(function(){
    PLG_showModalAlerta($(this).data("alerta-titulo"),$(this).data("alerta-texto"));
  });

  /**
   * LISTENER cierre cookies
   */
  $("#modal-cookies .close").click(function(){
    $("#modal-cookies").fadeOut();
    setCookie("aceptacion-cookies", "true", 365);
  });
  checkCookie("aceptacion-cookies");

  /**
   * LISTENER copiar de un input
   */
  $(".js-btn-copy").click(function() {
      var target=$(this).data("target-copy");
      copyToClipboard(document.getElementById(target));
  });


/**
 * funcion parallax de movimiento raton
 * [necesita clase js-parallaxElement]
 * [atributo data-movimientopxy] -> para indicar velocidad Y
 * [atributo data-movimientopxx] -> para indicar velocidad X
 */
  $( document ).mousemove( function( e ) {
    //variables globales
    ancho=$(window).width()/2;
    alto=$(window).height()/2;
    posx=e.clientX-ancho;
    posy=e.clientY-alto;
    pctx=parseInt(posx*100/ancho,10);
    pcty=parseInt(posy*100/alto,10);
    $('.js-parallaxMouse').each(function(index, el){
      tempx=pctx*parseInt($(this).attr("data-movimientopxx"),12)/100*-1;
      tempy=pcty*parseInt($(this).attr("data-movimientopxy"),12)/100*-1;
      $(this).css({
        '-ms-transform': 'translate('+tempx+'px, '+tempy+'px)',
        '-webkit-transform': 'translate('+tempx+'px, '+tempy+'px)',
        'transform': 'translate('+tempx+'px, '+tempy+'px)'
      });
    });
    $(".js-alphaElement").each(function(index, el) {
      if ($(window).scrollTop() < parseInt($(this).attr("data-topescroll"),10)){
        pct=e.clientX*100/$(window).width();
        $(this).find("img").css({
          'opacity': pct/100,
        });
      }
    });
  });


/**
 * funcion parallax de movimiento scroll
 * [necesita clase js-parallaxScroll]
 * [atributo data-movimientopxy] -> para indicar velocidad Y
 */
  $( window ).scroll( function( e ) {
    //variables globales
    alto=$(window).height()/2;
    posy=$(window).scrollTop();
    pcty=parseInt(posy*100/alto,10);

    $('.js-parallaxScroll').each(function(index, el){
      tempy=pcty*parseInt($(el).attr("data-movimientopxy"),12)/100*-1;
      $(el).css({
        '-ms-transform': 'translateY('+tempy+'px)',
        '-webkit-transform': 'translateY('+tempy+'px)',
        'transform': 'translateY('+tempy+'px)'
      });
    });
  });

};


